module.exports = __webpack_public_path__ + "img/no_picture_scenic_spot.13f142ed.jpg";